const SET_INIT = state => {
  state.isOpenRadio = false
  state.isOpenSelect = false
  state.startDate = ''
  state.endDate = ''
  state.month = 1
  state.selectedMonth = 0
  state.monthArr = state.monthArr.slice(0, 0)
}
const SHOW_OPEN_RADIO = (state, bool) => (state.isOpenRadio = bool)
const SET_OPEN_SELECT = (state, bool) => (state.isOpenSelect = bool)
const SET_START_DATE = (state, date) => (state.startDate = date)
const SET_END_DATE = (state, date) => (state.endDate = date)
const SET_MONTH = (state, month) => (state.month = month)

const SET_SELECTED_YEAR = (state, year) => (state.selectedYear = year)
const SET_SELECTED_MONTH = (state, month) => (state.selectedMonth = month)

export default {
  SET_INIT,
  SHOW_OPEN_RADIO,
  SET_OPEN_SELECT,
  SET_START_DATE,
  SET_END_DATE,
  SET_MONTH,
  SET_SELECTED_YEAR,
  SET_SELECTED_MONTH
}
